import { onboardingRequestDetailApi } from '../api/OnboardingRequestDetailApi'

class ProgressService {
  public fetchProfilingProgress = (partnerId: string, requestId: number) => {
    return onboardingRequestDetailApi.getProfilingProgress(partnerId, requestId)
  }

  public fetchLRProgress = (requestId: number) => {
    return onboardingRequestDetailApi.getLRProgress(requestId)
  }

  public fetchContractSignatureProgress = (requestId: number) => {
    return onboardingRequestDetailApi.getContractSignatureProgress(requestId)
  }
}

export const progressService = new ProgressService()
